import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';


import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ActivityLog from '../ActivityLog';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import $ from "jquery";
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';


function Master_aws_data() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [countryData, setCountryData] = useState([]);
    const [showAddEditForm, setAddEditFormShow] = useState(false);
    const [showAddNewBtn, setShowAddNewBtn] = useState(true);

    const [srNo, setSrNo] = useState(0);
    const [country, setCountry] = useState("");
    const [nationality, setNationality] = useState("");
    const [swiftCode, setSwiftCode] = useState("");

    const [remark, setRemark] = useState("");

    const [status, setStatus] = useState(0);
    const [ddActiveOptions, setDdActiveOptions] = useState([]);

    const [fatf, setFatf] = useState(0);
    const [ddFatfOptions, setDdFatfOptions] = useState([]);

    const [userRight, setUserRight] = useState([]);

    const [classData, setClassData] = useState([]);
    const [cClass, setCClass] = useState(0);

    const [formMode, setFormMode] = useState('Q'); // Q A E 

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");


    const [compareData, setCompareData] = useState([]);
    const [search, setSearch] = useState("");

    function addNew() {
        setSrNo(0);
        // setActivityLog([]);
        setCountry("");
        setNationality("");
        setSwiftCode("");
        setFatf(0);
        setStatus(1);
        setFormMode('A');
        setCClass(0);

        setAddEditFormShow(true);
        setShowAddNewBtn(false);
    }

   

    const cancelConfirm = () => {
        if (formMode === "A" || formMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
       
    }

    
    const fetchAwsData = () => {
         $(".loader").show();
        var obj = {
            prefix: search
        }
        Common.callApi(Common.apiAWS, [sid, "awsFetchData", JSON.stringify(obj)], async (result) => {
            let data=JSON.parse(result)
            $(".loader").hide();
              if(data.status==false){
                setMsgText(data.message);
                setMsgBox(true);
              }else{

                  setCountryData(data);
              }
        })
    }

    let showImage=(url)=>{
        if(url!=""){
            window.open(url,"_blank")
        }
    }

    const btnDownloadDoc = (url) => {
        if (url) {
            const link = document.createElement("a");
            link.href = url;
            link.download = "";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    

    return (
        <>
            <LoginHeader />
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>AWS Master List</h1>
                    </Col>
                </Row>
              
                    <Row>
                        <Col md={4}>
                        <Form.Group>
                            <Form.Label>Search<span className="mandatory text-danger">*</span></Form.Label>
                            <Form.Control type="text" placeholder="Search" maxLength={50}
                                value={search}
                                onChange={(e) =>setSearch(e.target.value)}
                                autoComplete="off"
                                required />
                        </Form.Group>
                        </Col>

                    </Row>
         


                 <Row>
                        <Col>

                              <Button variant="outline-primary" className='buttonStyle mb-3 mt-4' size="sm" onClick={fetchAwsData}>AWS fetch Data</Button>
                        </Col>
                </Row>
                    <Row>
                        <Col >
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        {userRight.edit === "1" ? <th></th> : null}
                                        <th className="textRight">Sr No</th>
                                        <th >File Path</th>
                                     
                                        <th >Action</th>

                                    </tr>
                                </thead>
                                <tbody id="tblBody">
                                    {countryData.map((res,index) =>
                                        <tr key={index+1}>
      
                                            <td className="textRight">{index+1}</td>
                                            <td>{res.key}</td>
                                          
                                            <td>

                                                {(
                                                res.type == "pdf" ||
                                                res.type == "jpeg" ||
                                                res.type == "gif" ||
                                                res.type == "jpg" ||
                                                res.type == "png" ||
                                                res.type == "webp"
                                                )&& (
                                                    <span
                                                        onClick={() => showImage(res.url)}
                                                            style={{ color: "blue", cursor: "pointer" }}
                                                    >
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </span>
                                                )}
                                                &nbsp;
                                                <span style={{ color: "blue", cursor: "pointer" }} onClick={() => btnDownloadDoc(res.url)}>
                                                    <FontAwesomeIcon icon={faFileDownload} />
                                                </span>

                                            </td>
           
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                
            </Container>

            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
            </div>
        </>
    );
}
export default Master_aws_data;